export default __webpack_public_path__ + "static/media/trustedby6.683b9deb.svg";